// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__299qe","rowsWrapper":"style_rowsWrapper__3dq4D","rowWrapper":"style_rowWrapper__3IXM1","edit_wrapper":"style_edit_wrapper__3nrDH"};